/**
 * The Mask
 * https://github.com/vuejs-tips/vue-the-mask#readme
 */

import Vue from 'vue';
import VueTheMask from 'vue-the-mask';

Vue.use(VueTheMask);
